export default class BefehlsnachrichtStatusTransitionError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'BefehlsnachrichtStatusTransitionError'
  }
}
